import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function Conversations() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/conversations").then((r) => {
      setItems(r.data.conversations);
      if (r.data.conversations[0]) setSelected(r.data.conversations[0].id);
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!selected) return;
    api.get(`/conversations/${selected}`).then((r) => setDetail(r.data));
  }, [selected]);

  return (
    <div className="p-8 lg:p-10" data-testid="dashboard-conversations">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#8c9b86]">Chat</div>
        <h1 className="font-serif-display text-4xl mt-2">Conversations</h1>
      </div>
      <div className="mt-8 grid md:grid-cols-[320px_1fr] gap-4 h-[70vh]">
        <div className="rounded-lg border border-[#e5e2da] bg-white overflow-y-auto dash-scroll" data-testid="conversations-list">
          {loading && <div className="p-6 text-sm text-[#5c5c5c]">Loading…</div>}
          {!loading && items.length === 0 && <div className="p-6 text-sm text-[#5c5c5c]">No conversations yet. Try the widget on the landing page.</div>}
          {items.map((c) => (
            <button
              key={c.id}
              onClick={() => setSelected(c.id)}
              data-testid={`conversation-${c.id}`}
              className={`w-full text-left px-4 py-3 border-b border-[#e5e2da] transition-colors ${selected === c.id ? "bg-[#efece5]" : "hover:bg-[#f9f8f6]"}`}
            >
              <div className="flex items-center justify-between">
                <div className="text-sm font-medium truncate">{c.lead?.name || "Anonymous visitor"}</div>
                <div className="text-[10px] text-[#8c9b86]">{c.message_count} msgs</div>
              </div>
              <div className="text-xs text-[#5c5c5c] mt-1 line-clamp-1">{c.last_message}</div>
              {c.lead && <Badge className="mt-2 capitalize" style={{ background: "#ebe8e0", color: "#163325", fontWeight: 500 }}>{c.lead.status}</Badge>}
            </button>
          ))}
        </div>
        <div className="rounded-lg border border-[#e5e2da] bg-white p-6 overflow-y-auto dash-scroll" data-testid="conversation-detail">
          {!detail && <div className="text-sm text-[#5c5c5c]">Select a conversation.</div>}
          {detail && (
            <>
              <div className="flex items-baseline justify-between pb-4 border-b border-[#e5e2da]">
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#8c9b86]">Session</div>
                  <div className="font-serif-display text-2xl mt-1">{detail.lead?.name || "Anonymous"}</div>
                  {detail.lead && <div className="text-sm text-[#5c5c5c]">{detail.lead.email}</div>}
                </div>
                <div className="text-xs text-[#5c5c5c]">{detail.session?.created_at?.slice(0, 16).replace("T", " ")}</div>
              </div>
              <div className="mt-4 space-y-3">
                {detail.messages.map((m, i) => (
                  <div key={i} className={`max-w-[75%] text-sm ${m.role === "user" ? "ml-auto" : ""}`}>
                    <div className="text-[10px] uppercase tracking-wider text-[#8c9b86] mb-1">{m.role === "user" ? "Visitor" : "Coachly"}</div>
                    <div className="px-3 py-2 rounded-2xl" style={m.role === "user"
                      ? { background: "#163325", color: "#f9f8f6", borderBottomRightRadius: 4 }
                      : { background: "#ebe8e0", color: "#1c1c1c", borderBottomLeftRadius: 4 }
                    }>{m.content}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
